module.exports = __webpack_public_path__ + "img/profit-icon2.b6dc953e.png";